import styled from 'styled-components';

export const Container = styled.div`
  > h2 {
    padding: 20px 10px 10px;
  }
`;
